import { Text } from "basis";
import { FullAddress as FullAddressType } from "library/api/address/types.generated";
import { formatMaskedValue } from "library/utils";

type Props = { address: string | FullAddressType };

export const Address = ({ address }: Props) => {
  if (typeof address === "string") {
    return <Text testId="masked-address">{formatMaskedValue(address)}</Text>;
  }

  return (
    <Text testId="full-address">
      {address.address1}
      {address.address2 !== "" && (
        <>
          <br />
          {address.address2}
        </>
      )}
      {address.city !== "" && (
        <>
          <br />
          {address.city}
        </>
      )}
      <br />
      {`${address.state} ${address.post_code}`}
      <br />
      {address.country}
    </Text>
  );
};
